import { Component, OnInit, ViewChild, Input, Output, HostListener, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import _ from 'lodash'
import * as moment from 'moment';
import { MatPaginator, MatDialog, MatSnackBar, PageEvent } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { UserTimeSheetService } from '../../services/user-time-sheet.service'
import { LearnerService } from '../../services/learner.service'
import { TimeSheetService } from '../../services/time-sheet.service';
import { saveAs } from "file-saver";
import { JobHoursModelComponent } from './job-hours-model/job-hours-model.component';
import { Observable } from 'rxjs';
import { UtilityService } from 'src/app/services/utility.service'
import { learnerType } from '../../_models/staticArray'

@Component({
  selector: 'app-learner-single-week',
  templateUrl: './learner-single-week.component.html',
  styleUrls: ['./learner-single-week.component.scss']
})

export class LearnerSingleWeekComponent implements OnInit {
  @Input('calWeekDates') doGetWeekDates;
  @Input('learner') learner;
  @Input('overTimeHours') overTimeHours;
  @Input('learnerWeekArray') datesArrayFromLearner;
  @Input('weekDatesFromAdmin') weekDatesFromAdmin;
  @Input('monthChanged') monthChanged;
  @Input('jobId') jobId
  @Input('learnerDetails') selectedLearner
  @Input('allWeeks') weeks
  @Input('changeMonthDates') monthChangeValue
  @Input('isMonthClear') isMonthClear
  @Input('otjh') offTheJobHrs
  currentTime;
  learnerSelectType
  learnerType = learnerType
  totalHours = 0;
  showPasteBtn
  overH
  overM
  copiedIndex
  finalArray = []
  totalMinutes = 0;
  deletedLog = [];
  totalHoursWorked = { hours: 0, minutes: 0 };
  showTotalHoursColor
  loading
  Days = [];
  datesOfWeek;
  currentPage
  displayMsg
  hideActions = true;
  editing: boolean = false
  index
  editedIndex = [];
  arrayFromDb = []
  selectedJob
  learnerData
  hoursValid = true
  // totalHoursWorked
  // Days = [
  //   { id: '0', date: '02/11/2020', start: '00:00', finish: '00:00', hoursWorked: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '02:00', day: 'Sunday', checked: false },
  //   { id: '1', date: '02/12/2020', start: '00:00', finish: '00:00', hoursWorked: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '00:10', day: 'Monday', checked: false },
  //   { id: '2', date: '02/13/2020', start: '00:00', finish: '00:00', hoursWorked: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '20:00', day: 'Tuesday', checked: false },
  //   { id: '3', date: '02/14/2020', start: '00:00', finish: '00:00', hoursWorked: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '20:00', day: 'Wednesday', checked: false },
  //   { id: '4', date: '02/15/2020', start: '00:00', finish: '00:00', hoursWorked: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '20:00', day: 'Thursday', checked: false },
  //   { id: '5', date: '02/16/2020', start: '00:00', finish: '00:00', hoursWorked: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '20:00', day: 'Friday', checked: false },
  // ];
  isPrint = true;
  // constructor(private _userTimeSheetServices: UserTimeSheetService, private _learnerService: LearnerService, private _snackBar: MatSnackBar, private _timeSheetSetvice: TimeSheetService, public dialog: MatDialog) { }
  // displayedColumns: string[] = ['copyPaste', 'date', 'start', 'finish', 'hoursWorked', 'details', 'otherdetails', 'edit', 'reset',];
  // displayedColumns: string[] = ['copyPaste', 'weekNumber', 'weekStart', 'weekEnd', 'hoursWorked', 'details', 'otherDetails', 'edit', 'reset']
  dataSource: MatTableDataSource<any>;
  pageSizeOptions: number[] = [25, 50, 100];
  sort: MatSort;
  paginator: MatPaginator;
  // isPrint = true;
  displayedColumns: string[] = ['copyPaste', 'weekNumber', 'weekStart', 'weekEnd', 'hoursWorked', 'details', 'otherDetails', 'edit', 'reset', 'view']
  user: any;
  isStaff: boolean = false;
  totalWorkingHoursCount: any;
  totalOTJH
  percent: string;
  isDisplay: boolean = false
  totalHoursValid: boolean = true;
  regex2: RegExp;
  regex1: RegExp;

  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }


  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(private _userTimeSheetServices: UserTimeSheetService, private _learnerService: LearnerService, private _snackBar: MatSnackBar, private _timeSheetSetvice: TimeSheetService, public dialog: MatDialog) {
    this.dataSource = new MatTableDataSource<any>(this.Days);
  }
  // displayedColumns: string[] = ['copyPaste', 'date', 'start', 'finish', 'hoursWorked', 'details', 'otherdetails', 'edit', 'reset',];
  // displayedColumns: string[] = ['copyPaste', 'weekNumber', 'weekStart', 'weekEnd', 'hoursWorked', 'details', 'otherDetails', 'edit', 'reset']
  // dataSource: MatTableDataSource<any>;
  // pageSizeOptions: number[] = [25, 50, 100];
  // sort: MatSort;
  // paginator: MatPaginator;
  // isPrint = true;
  // displayedColumns: string[]
  displayedColumns1: string[] = ['copyPaste', 'weekNumber', 'weekStart', 'weekEnd', 'hoursWorked', 'details', 'otherDetails', 'edit', 'reset', 'view']
  displayedColumns2: string[] = ['copyPaste', 'weekNumber', 'weekStart', 'weekEnd', 'hoursWorked', 'details', 'otherDetails', 'view']
  // totalWorkingHoursCount: any;
  // totalOTJH
  // percent: string;
  // isDisplay: boolean = false
  // totalHoursValid: boolean = true;
  // regex2: RegExp;
  // regex1: RegExp;

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("login user role======", this.user);
    if (this.user.isTrainer || this.user.isMp || this.user.isIQA || this.user.isStaff)
      this.isStaff = true

    if (this.isStaff)
      this.displayedColumns = this.displayedColumns2
    else
      this.displayedColumns = this.displayedColumns1
    // this.getCurrentMonthWeeks()
    // this.getWeekDates()
    // if (this.datesOfWeek) {
    // this.getDays();
    // this.getValuesUsingDates();
    // }
    // else if (this.doGetWeekDates == true) {
    // console.log("**On init this.instructorId", this.instructorId);
    // this.instructorId = this.instFromAdminReport;
    // this.displayMsg = false;
    // this.selectedDate = moment().format("MM/DD/YYYY")
    // this.getWeekDates();
    // }
    // this.getTimeLogs()

    // this.dataSource = new MatTableDataSource(this.Days);
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
    // this.padZeroInLogs(this.Days)
  }



  ngOnChanges(changes: SimpleChanges): void {

    // console.log("ng on changes here !!!!!!!!!!!!!!!!!!!!!!!!!", changes)
    // if ((changes.monthChanged && changes.monthChanged.currentValue == true)  (changes.doGetWeekDates && changes.doGetWeekDates.currentValue == true)  (changes.isMonthClear && changes.isMonthClear.currentValue == true)) {
    //   // this.getWeekDates()
    //   console.log("check here work get week")
    // }
    if (changes.datesArrayFromLearner && changes.datesArrayFromLearner.currentValue) {
      this.datesOfWeek = changes.datesArrayFromLearner.currentValue
      this.getValuesUsingDates()
    }
    if (changes.jobId && changes.jobId.currentValue) {
      this.selectedJob = changes.jobId.currentValue
    }
    if (changes.selectedLearner && changes.selectedLearner.currentValue) {
      this.learnerData = changes.selectedLearner.currentValue
      console.log("learner data in chile component", this.learnerData);
      // this.getTimeLogs()

    }
    if (changes.monthChangeValue && changes.monthChangeValue.currentValue) {
      this.datesOfWeek = changes.monthChangeValue.currentValue
      // this.getTimeLogs()
    }
    if (changes.offTheJobHrs && changes.offTheJobHrs.currentValue) {
      this.totalOTJH = changes.offTheJobHrs.currentValue
    }

    if (changes.selectedLearner && changes.selectedLearner.currentValue && changes.offTheJobHrs && changes.offTheJobHrs.currentValue) {
      this.getTimeLogs()
    } else if (changes.monthChangeValue && changes.monthChangeValue.currentValue && changes.weeks && changes.weeks.currentValue) {
      this.getTimeLogs()
    } else if (changes.monthChangeValue && changes.monthChangeValue.currentValue && changes.monthChangeValue.previousValue != undefined) {
      this.getTimeLogs()
    }

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getCurrentMonthWeeks() {
    this._timeSheetSetvice.getSystemDate().subscribe(date => {
      console.log('system Date', date)
      let temp = new Date(date.split('T')[0])
      console.log('temp', temp)
    })
  }
  /***
   * *************************************
   * ***********
   * table update function 
   */
  getedit() {
    this.updateData(this.Days);
  }

  updateData(weekDays) {
    console.log("UPDATING DATA = ", weekDays)
    // this.padZeroInLogs(weekDays)
    this.dataSource = new MatTableDataSource(weekDays);


    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property)
      switch (property) {
        // case 'displayTitle': return item.assignment.title
        // case 'deadlineDate': return item.deadlineDate;
        // case 'type': return item.assignment.type
        // case 'status': return item.status

        default: return item[property]
      }
    }

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    this.loading = false
  }



  padZeroInLogs(logs) {
    let count = 0;
    return new Promise((resolve, reject) => {
      if (logs && logs.length) {
        logs.forEach(async folder => {
          const result = await this.padZeroInOneLog(folder);
          count++;
          if (count == logs.length) {
            resolve()
          }
        })
      } else {
        resolve()
      }
    })
  }


  padZeroInOneLog(log) {

    return new Promise((resolve, reject) => {
      log.logIn = this.padZero(log.logIn)
      log.logOut = this.padZero(log.logOut)
      // log.workingHours = this.padZero(log.workingHours)
      // log.totalHours = this.padZero(log.totalHours)
      // log.travel = this.padZero(log.travelHours)
      resolve(log)
    })
  }

  padZero(value) {
    const digit = value.split(':');
    let data = String(this.padString(digit[0])) + ':' + String(this.padString(digit[1]));
    return data;
  }

  padString(value) {
    if (Number(value) < 10 && value.length != 2) {
      return '0' + value;
    } else {
      return value;
    }
  }

  timeChanged(event, index) {
    this.currentTime = event;
    console.log("this.currentTime", this.currentTime);
  }
  eventFromTimePicker(event) {
    console.log("eventFromTimePicker($event)", event);
  }

  invalidMsg(this) {
    console.log("invalidMsg called", this)
    this.hoursValid = false
  }

  openModel(val, i) {
    val['weekNo'] = i + 1
    let data = {
      data: val,
      deletedLog: this.deletedLog,
      jobId: this.jobId,
      learner: this.learnerData.userId,
    }
    console.log("data pass in model", data);
    this.openDialog(JobHoursModelComponent, data).subscribe(res => {
      console.log("updated data get", res);
      if (res == undefined) return
      else this.getTimeLogs()
    })
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }



  /***
   * date update function here !!!!!!!!!!!!!!!!!!!!!!!!!1
   */
  edit(i, pageEvent) {
    this.hoursValid = true;
    console.log("what is the index value", i);

    this.Days[i]['updated'] = true
    if (pageEvent && pageEvent.pageIndex) {
      this.currentPage = pageEvent.pageIndex
    }
    else { this.currentPage = 0 }
    console.log("On edit adding class to", '#' + this.currentPage + i);
    $('#' + this.currentPage + i).addClass('make-blue')
    console.log("index", i);
    this.index = i
    this.editedIndex.push({ currentPage: this.currentPage, index: i })
    console.log("in edit this.editedIndex", this.editedIndex);
    this.editing = true
    console.log("this is the selected index data", this.index);

    console.log("**CURRENT PAGE", this.currentPage);

  }



  addTimeLogs(event) {
    console.log("event when enter something", event.target.value);
    let regex = new RegExp(/^([0-9][0-9]):[0-5][0-9]$/g)
    this.hoursValid = regex.test(event.target.value);
    if (this.hoursValid) {

      console.log("this.houursValid", this.hoursValid)
      this.totalWorkingHours()
    } else {
      console.log("this is not valid");

    }

  }

  addOTJHTimeLogs(event) {
    console.log("event when enter something", event.target.value);
    let regex = new RegExp(/^([0-9]{1,3}):[0-5][0-9]$/g)
    this.totalHoursValid = regex.test(event.target.value);
    if (this.totalHoursValid) {
      this.isDisplay = true
      console.log("this.houursValid", this.totalHoursValid)
      // this.totalWorkingHours()
    } else {
      console.log("this is not valid");
      this.isDisplay = false
    }

  }

  pageNext(event) {
    this.editing = false
    this.index = null
    console.log("**event", event);
    console.log("**this.editedIndex", this.editedIndex);
    this.currentPage = event.pageIndex;
    if (this.editedIndex) {
      this.editedIndex.forEach(i => {
        console.log("i", i);
        if (this.currentPage == i.currentPage) {
          console.log("adding class to", '#' + i.currentPage.toString() + i.index.toString());
          $(document).ready(function () {
            console.log("ready!");
            $('#' + i.currentPage.toString() + i.index.toString()).addClass('make-blue')

          });
        }
      })
    }
  }




  /****
   * *****************************************************************
   * get Week Days .......................
   */


  getWeekDates() {
    console.log("**getWeekDates called")
    this.displayMsg = false;
    console.log("-----getWeekDates-----", moment().startOf('week'), moment().endOf('week'));
    let weekStartDate = moment().startOf('week')
    let weekEndDate = moment().endOf('week')
    let dates = []
    // // return new Promise((resolve,reject)=>{
    dates.push(weekStartDate.format('MM/DD/YYYY'))
    return new Promise((resolve, reject) => {
      while (weekStartDate.add(1, 'days').diff(weekEndDate) < 0) {
        console.log("In while loop");
        console.log(weekStartDate.toDate());
        dates.push(weekStartDate.clone().format('MM/DD/YYYY'));
      }
      resolve(dates)
      this.datesOfWeek = dates;

      console.log(" AFTER WHILE **dates", dates);
      // })
    }).then((resolvedArray) => {
      console.log("resolve array data ********************************")
      this.getTimeLogs()
      this.getValuesUsingDates()


    })
  }


  checkTotalWorkHour(hours, minutes) {
    // console.log("***checkTotalWorkHour", hours, minutes, typeof minutes);
    if (hours > 11 && minutes > 0) {
      // console.log("***checkTotalWorkHour", "hours", hours, "minutes", minutes);
      return 'break';
    } if (hours == 12 && minutes == 0) {
      return 'ok';
    }
    else {
      return 'ok';
    }
  }


  /**
   * ***********************************
   * learner data get
   */








  getValuesUsingDates() {
    this.loading = true
    // if (this.datesOfWeek) { this.regularHours = this.datesOfWeek.length * 12 }
    // console.log('Get Values Using Dates');
    // let data = {
    //   date: this.datesOfWeek,
    //   instructorId: this.instructorId,
    //   pageSize: this.pageSize,
    //   pageIndex: this.pageIndex,
    // }
    // console.log('%cGETTING TIME LOGS FUNCTION CALLED', "color:red;font-weight:bold")
    // console.table(data)
    // if (data.date && data.instructorId) {
    //   this._timeSheetService.getTimeLogUsingDates(data).subscribe(res => {
    //     console.log('Inside Res===========>>>>', res);
    //     this.arrayFromDb = res;
    //     this.editing = false
    //     this.index = null
    //     this.loading = false

    //     // if (res.data) {
    //     //   this.arrayFromDb = res.data;
    //     //   this.Days = res.data
    //     //   this.updateData(this.Days);
    //     // }

    //     // if (res.total) {
    //     //   this.totalSize = res.total;
    //     // }


    //     console.log('Arrayform db', this.arrayFromDb);
    //     this.mergeAndCompareBothArrays();
    //   }, error => {

    //   })

    this.mergeAndCompareBothArrays()
    // }
  }


  /**********************************************************
   * *********week date initilize value*********************************
   */

  mergeAndCompareBothArrays(array?) {
    console.log("this is the array which get", array);

    console.log("here is the ", this.datesOfWeek)

    let weekDates = this.datesOfWeek.filter((o) => {
      console.log("single date value", o.from);

      // let newDate = new Date(o.weekStartDate)
      // return ((newDate.getMonth() > 8) ? (newDate.getMonth() + 1) : ('0' + (newDate.getMonth() + 1))) + '/' + ((newDate.getDate() > 9) ? newDate.getDate() : ('0' + newDate.getDate())) + '/' + newDate.getFullYear()
    })

    var filterDates;
    this.arrayFromDb = [];
    if (array && array.length != 0) {
      this.arrayFromDb = array
    }
    // this.arrayFromDb = array;
    console.log("ARRAY FROM DB", this.arrayFromDb);
    console.log("this.datesOfWeek", this.datesOfWeek);
    // this.Days = this.arrayFromDb;
    // this.updateData(this.Days);
    // this.totalWorkingHours();
    return new Promise((resolve, reject) => {

      filterDates = this.datesOfWeek.filter(o => !this.arrayFromDb.find(o2 => o.from === o2.date))
      console.log('Fiter Dates===>>>>', filterDates);
      _.forEach((filterDates), (singleDate, index) => {
        console.log("what is single date data", singleDate);

        let newObj;
        let startingDate = new Date(singleDate.weekStartDate)
        newObj = {
          date: ((startingDate.getMonth() > 8) ? (startingDate.getMonth() + 1) : ('0' + (startingDate.getMonth() + 1))) + '/' + ((startingDate.getDate() > 9) ? startingDate.getDate() : ('0' + startingDate.getDate())) + '/' + startingDate.getFullYear(),
          weekNumber: singleDate.weekNumber,
          weekStartDate: new Date(singleDate.weekStartDate),
          weekEndDate: new Date(singleDate.weekEndDate),
          minutes: '00',
          hours: '00',
          _id: 'new',
          details: {
            extraDetails: '',
            other: '',
          },
          workingHours: '00:00',
        }
        this.arrayFromDb.push(newObj);
      })
      resolve(this.arrayFromDb)
    }).then((resolvedArray: any) => {
      this.arrayFromDb = (resolvedArray.sort(function (a, b) {
        return <any>new Date(b.date) - <any>new Date(a.date);
      })).reverse();
      this.Days = this.arrayFromDb;
      console.log("this are the total days to be update", this.Days);

      this.updateData(this.Days);
      this.totalWorkingHours();
      // this.calcOverTime()
    })
  }


  /***
   * ****************************************
   * caculate  diffrence working hours 
   */
  calculateDiff1 = (index) => {
    console.log("CalculateDiff 1");
    var startTime = this.Days[index].logIn;
    var startHours = startTime.split(":")[0]
    var startMinutes = startTime.split(":")[1]
    var endTime = this.Days[index].logOut;
    var endHours = endTime.split(":")[0]
    var endMinutes = endTime.split(":")[1]
    var date = moment(this.Days[index].date);
    var time1: any = new Date(date.toDate().setHours(startHours, startMinutes)) //new Date(date + ' ' + startTime + ':00 GMT+0000');
    var time2: any = new Date(date.toDate().setHours(endHours, endMinutes))//new Date(date + ' ' + endTime + ':00 GMT+0000');
    var difference = (time2 - time1) / 60000;
    console.log("Difference", difference);
    var minutes = difference % 60;
    console.log("minutes", minutes);
    var hours = (difference - minutes) / 60;
    console.log("hours", hours);
    return ({ hours: hours, minutes: minutes })
  }


  /**
   * timepicker close time call function
   */

  closed(index) {

    console.log('Closed Function', this.Days[index]);
    if (this.Days[index].logIn != '00:00' && this.Days[index].logOut != '00:00') {
      var diff1 = this.calculateDiff1(index)
      // var diff2 = this.calculateDiff2(index)
      let hoursWorking = diff1.hours
      console.log("-----hoursWorking-----", hoursWorking);
      let totalMinute = diff1.minutes
      console.log("-----totalMinute-----", totalMinute);
      if (totalMinute > 60) {
        // tempWeeklyHours = tempWeeklyHours + Math.floor(tempWeeklyMinutes / 60)
        // tempWeeklyMinutes = tempWeeklyMinutes % 60
        totalMinute = totalMinute % 60;
        console.log("-----total Minutes----", totalMinute);
        console.log("-----total Minutes/60----", totalMinute / 60);
        console.log("--IN IF--totalMinute", totalMinute);
        hoursWorking = hoursWorking + Math.floor(totalMinute / 60)
        console.log("--IN IF--hoursWorking", hoursWorking);
        this.Days[index].workingHours.hours = hoursWorking;
        this.Days[index].workingHours.minutes = totalMinute;
      }
      else if (totalMinute == 60) {
        this.Days[index].workingHours.hours = hoursWorking + 1;
        this.Days[index].workingHours.minutes = totalMinute - 60;
      }
      else {
        this.Days[index].workingHours.hours = hoursWorking;
        this.Days[index].workingHours.minutes = totalMinute;
      }

      // this.totalWorkingHours();
      // this.calcOverTime();
    }
    this.updateData(this.Days);
    this.totalWorkingHours();


  }



  /***
   * *************************************************************
   * Total working hours ***************************************************
   */
  totalWorkingHours() {
    console.log("this.Days", this.Days);
    console.log('call After Api call');
    var totalH = 0;
    var totalM = 0;
    _.forEach(this.Days, (day, index) => {
      console.log("here is single day value!!!!!!", day)
      let hours = day.workingHours.split(':')
      console.log("what is the split value", hours);

      totalH = totalH + Number(hours[0]);
      totalM = totalM + Number(hours[1]);
    })
    if (totalM > 60) {
      totalH = totalH + Math.floor(totalM / 60)
      totalM = totalM % 60
      this.totalHoursWorked.hours = totalH;
      this.totalHoursWorked.minutes = totalM;
      console.log('This.totalHoursWorked', this.totalHoursWorked);

      // this.checkTravelPlusWorkHour()
    } else if (totalM == 60) {
      this.totalHoursWorked.hours = totalH + 1;
      this.totalHoursWorked.minutes = totalM - 60
      console.log('This.totalHoursWorked', this.totalHoursWorked);

    }
    else {
      this.totalHoursWorked.hours = totalH;
      this.totalHoursWorked.minutes = totalM;
      console.log('This.totalHoursWorked', this.totalHoursWorked);

    }
    console.log('This.totalHoursWorked', this.totalHoursWorked);
  }



  /***
   * ************************************************
   * check total working **********************************
   */
  checkTotalWorkingHours(hours) {
    if (this.showTotalHoursColor == true) {
      if (hours >= 72) {
        return 'break';
      } else {
        return 'ok';
      }
    }
    else return 'ok';
    // console.log('Check Total Working Hours===>>>', hours);

  }


  /***
   * ******************************************************************
   * reset time log current row*****************************************
   */





  resetCurrentLogs(index) {
    console.log('Reset Logs here:', index)
    this.Days[index].logIn = '00:00';
    this.Days[index].logOut = '00:00';
    this.Days[index].details = '';
    // this.Days[index].other = '';
    this.Days[index].workingHours = '00:00';
    // this.Days[index].workingHours.minutes = 0;
    this.Days[index].totalHours.hours = 0;
    this.Days[index].totalHours.minutes = 0;
    this.Days[index].reset = true;
    this.Days[index].details = {
      extraDetails: '',
      other: ''
    }
    if (this.Days[index]._id && this.Days[index]._id != 'new') {
      this.deletedLog.push(this.Days[index]._id)
      // this.Days[index].reset = false;

    }

    console.log('Deleted Logs==>', this.deletedLog);

    this.totalWorkingHours();
    // this.calcOverTime();
  }



  /****
   * copy pest using button timeloh
   */

  copyCurrentLogs(i) {
    this.copiedIndex = i;
    this.showPasteBtn = true

  }
  pasteLogs(i) {
    console.log("index of paste logs", i);

    this.showPasteBtn = false
    let newLogs = this.Days[i]
    console.log("this has been paste logs", newLogs);

    newLogs.logIn = this.Days[this.copiedIndex].logIn;
    newLogs.logOut = this.Days[this.copiedIndex].logOut;
    newLogs.details.extraDetails = this.Days[this.copiedIndex].details.extraDetails;
    newLogs.details.other = this.Days[this.copiedIndex].details.other;
    // newLogs.weekStartDate = this.Days[this.copiedIndex].weekStartDate
    // newLogs.other = this.Days[this.copiedIndex].other;
    newLogs.workingHours = this.Days[this.copiedIndex].workingHours
    // this.closed(i)
    $('#' + this.currentPage + i).addClass('make-blue')
    this.editedIndex.push({ currentPage: this.currentPage, index: i })
    // this.edit(i,this.currentPage)
    console.log("after paste logs", newLogs);

    console.log("THIS.DAYS", this.Days);
    this.totalWorkingHours();
  }



  /***
   * learner submit time logs function
   */

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  submitDetail() {
    // this.loading = true
    this.finalArray = []
    _.forEach((this.Days), (singleDate, index) => {
      console.log('this.Days===========>>>>>>', this.Days);
      console.log('singleDate===========>>>>>>', singleDate);
      if (singleDate.workingHours != '00:00' || singleDate._id != 'new') {
        this.finalArray.push(singleDate);
      }
    })

    let data = {
      date: this.finalArray,
      deletedLog: this.deletedLog,
      jobId: this.jobId,
      learner: this.learnerData.userId,
      // details: this.learnerSelectType
      // instructorId: this.instructorId
    }
    console.log('finalArray===========>>>>>>', data);
    this._userTimeSheetServices.addTimelog(data).subscribe((res) => {
      //   this.finalArray = [];
      //   this.getValuesUsingDates()
      // this.editing = false;
      this.index = -1;
      console.log("timelog data added successfully!!!", res)
      this.getTimeLogs()
      this.openSnackBar("Logs added successfully!", "OK")
      this.loading = false
    }, err => {
      console.log("here is some error occure!!!", err)
      this.loading = false
    })
  }



  getTimeLogs(test?) {
    this.loading = true
    console.log("get time log function call ***********************", this.datesOfWeek)

    const weekNumberArray = this.datesOfWeek.map(function (value) {

      let date = new Date(value.weekStartDate)
      let newDate = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
      let obj = {
        date: newDate,
        weekNumber: value.weekNumber
      }
      return obj
    })

    console.log("this is the weekNumberArray ", weekNumberArray);


    const data = {
      userId: this.learnerData.userId,
      jobId: this.jobId,
      date: weekNumberArray
    }
    this.loading = true
    this._userTimeSheetServices.getTimelog(JSON.stringify(data))
      .subscribe((res) => {
        console.log("response of data", res);
        this.totalWorkingHoursCount = res.totalHours
        this.calculatePercent(this.totalWorkingHoursCount, this.totalOTJH)
        this.arrayFromDb = res.result;
        this.editing = false
        this.index = null
        this.loading = false
        console.log('Arrayform db', this.arrayFromDb);
        // this.updateData(this.arrayFromDb)
        this.mergeAndCompareBothArrays(this.arrayFromDb);
        console.log("here is time log get response", res)
      }, (error) => {
        console.log("failed time log response gett", error);

      })
  }

  pad(value) {
    if (value < 10) {
      return '0' + value;
    } else {
      return value;
    }
  }


  totalWeekHour() {
    var totalH = 0;
    var totalM = 0;
    _.forEach(this.Days, (day) => {
      console.log("single day value", day);
      let totalTime = day.workingHours.split(':')

      totalH = totalH + Number(totalTime[0])
      totalM = totalM + Number(totalTime[1])
    })
    if (totalM > 60) {
      totalH = totalH + Math.floor(totalM / 60)
      totalM = totalM % 60
      // return totalM;
    } else if (totalM == 60) {
      this.overH = this.overH + 1
      totalM = totalM - 60
      this.overM = totalM;
      // return this.overM;
    }
    else {
      this.overM = totalM;
      // return this.overM;
    }
    totalH = this.pad(totalH)
    totalM = this.pad(totalM)
    return totalH.toString() + ':' + totalM.toString()
  }



  public printsingleWeekReport() {
    this.loading = true;
    let data = {
      logs: this.Days,
      periodStart: this.datesOfWeek[0].from,
      periodEnd: this.datesOfWeek[this.datesOfWeek.length - 1].to,
      totalWeekHours: this.totalWeekHour(),
      totalHoursWorked: this.totalHoursWorked,
      jobId: this.selectedJob,
      learner: this.learnerData.name,
      totalWorkingHours: this.totalWorkingHoursCount,
      totalRequiredHours: this.totalOTJH
    }

    console.log('Print Single Week Report ======>', data);
    this.openSnackBar("Download will start automatically.", "Ok");
    this._userTimeSheetServices.generateWeekReport(data).subscribe(res => {
      console.log('Success Response', res);
      if (res == undefined) return
      else {
        const downloadLink = document.createElement("a");
        downloadLink.href = res.pdfUrl;
        downloadLink.download = this.learnerData.name + '_offJobHours' + ".pdf"
        this.openSnackBar("PDF downloaded successfully!", "Ok");
        downloadLink.click()
        this.loading = false
      }
      // if (res && res.data) {
      //   this.saveToFileSystem(res.data)
      // }
    }, err => {
      console.log('Error while pdf', err);
      this.loading = false;
    })
  }


  private saveToFileSystem(response) {
    const byteArray = new Uint8Array(response);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const pdfName = this.learnerData.name + '_offJobHours'
    saveAs(blob, pdfName);
    this.openSnackBar("PDF downloaded successfully!", "Ok");
    this.loading = false;
  }

  calculatePercent(worked, otjh) {
    console.log("calculatePercent of ", worked, otjh)
    var timeone = worked.hours + ":" + worked.minutes; // time elapsed
    var timetwo = otjh; // total time 
    this.percent = (100 * this.totalSeconds(timeone) / this.totalSeconds(timetwo)).toFixed(2);
    if (this.percent == 'NaN') {
      this.percent = '0'
    }
    console.log("pct", this.percent, typeof this.percent)
  }

  totalSeconds(time) {
    console.log("time in totalSeconds", time)
    var parts = time.split(':');
    return parts[0] * 3600 + parts[1] * 60;
  }
  updateTotalOTJH() {
    this.isDisplay = false;
    console.log("here is the total hours to changed", this.totalOTJH, this.learner, this.jobId);
    let obj = {
      totalOTJH: this.totalOTJH,
      learnerId: this.learner,
      jobId: this.jobId
    }
    this._learnerService.updateTotalOTJH(obj).subscribe((updated) => {
      console.log("total OTJH updated", updated);
      this.openSnackBar("Total required hours update successfully!", "OK")
      this.calculatePercent(this.totalWorkingHoursCount, this.totalOTJH)
    }, err => {
      console.log("error while update logs", err);

    })
  }

}
